import { StatusLight } from '@racepointenergy/swc/scs/types/host'
import { mdiTooltipTextOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'

import { Mark } from 'components/Mark'
import Tooltip from 'components/Tooltip'
import { statusMarkings } from 'features/home/consts'

import {
  HomeStatusLabelsContainer,
  LightStatusContainer,
  IndicatorsContainer,
} from '../styles'

interface HomeLightStatusesProps {
  colorIdx: number
  status: string
  label: string
}

function HomeLightStatus({
  colorIdx,
  status = '',
  label,
}: HomeLightStatusesProps) {
  return (
    <LightStatusContainer>
      <IndicatorsContainer>
        <Mark
          marking={statusMarkings[colorIdx]}
          style={{ marginRight: '0.125rem' }}
        />
      </IndicatorsContainer>
      <HomeStatusLabelsContainer>{label}</HomeStatusLabelsContainer>
      {colorIdx > StatusLight.Green && colorIdx < StatusLight.Grey && (
        <Tooltip text={status} showOn="hover">
          <Icon
            path={mdiTooltipTextOutline}
            size={0.75}
            color="#807e7e"
            style={{ marginLeft: '0.5rem' }}
          />
        </Tooltip>
      )}
    </LightStatusContainer>
  )
}

export default memo(HomeLightStatus)
